// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-2e1e95c7],.page[data-v-2e1e95c7]{min-height:100vh}.loading[data-v-2e1e95c7]{background-color:rgba(0,0,0,.65);justify-content:center;align-items:center;position:fixed;display:flex;left:0;top:0;z-index:1005;min-width:100vw}header>.container[data-v-2e1e95c7]{background-size:auto 90%;background-repeat:no-repeat;background-position:100%}", ""]);
// Exports
module.exports = exports;
